import { gql } from '@apollo/client';

export const VACCINE_META_INFO_FRAGMENT = gql`
  fragment VaccineMetaInfoFragment on VaccineMetadata {
    id
    name
    uid
  }
`;
